function _identity(x) {
    return x;
}

export { _identity as _ };
